import { combineReducers } from "@reduxjs/toolkit";
import countriesSlice from "./countriesSlice";
import managedByDepartmentsSlice from "./managedByDepartmentsSlice";
import managedByJobTitlesSlice from "./managedByJobTitlesSlice";

const reducer = combineReducers({
  countries: countriesSlice,
  departments: managedByDepartmentsSlice,
  jobTitles: managedByJobTitlesSlice,
});

export default reducer;
